








import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import "../styles/icons-5.15.4-css-combined.min.css";

@Component({})
export default class FontAwesomeIcon extends Vue {
	@Prop() readonly icon!: [];
	@Prop({ default: "" }) readonly title!: string;
	@Prop({ default: false }) readonly spin!: boolean;
	@Prop({ default: "" }) readonly size!: "" | "lg" | "3x" | "4x" | "6x";
	@Prop({ default: "" }) readonly transform!: string;

	iconStr() {
		return this.icon.join(" fa-") + this.getSpin();
	}

	getSize() {
		if (this.size === "lg") {
			return "1.33333em";
		}
		if (this.size === "3x") {
			return "3em";
		}
		if (this.size === "4x") {
			return "4em";
		}
		if (this.size === "6x") {
			return "6em";
		}
		return "1em";
	}

	getSpin() {
		if (this.spin) {
			return " fa-spin";
		}
		return "";
	}
}
